module.exports = __webpack_public_path__ + "img/swiper2.1b97dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/swiper2.png
// module id = 386
// module chunks = 0